<template>
  <div class="appropriations-utils">
    <v-row class="criteria-row align-center" no-gutters>
      <v-col cols="12" sm="4" md="3" class="pr-sm-4 mb-2 mb-sm-0">
        <v-autocomplete
          id="war-criteria-fund"
          v-model="criteriaState.glFund"
          item-text="fundDesc"
          item-value="_id"
          :items="funds"
          label="By Fund"
          dense
          hide-details
          @change="searchByCriteria()"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="auto">
        <v-btn
          color="error"
          outlined
          small
          :disabled="!criteriaState.glFund || !editedItems.length"
          @click="clearAll"
        >
          Clear All
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
    dense
    :headers="headers"
    :items-per-page="-1"
    hide-default-footer
    :items="editedItems"
    class="elevation-1 war-appr-table mt-4"
  >
    <template v-slot:top>
      <div class="d-flex justify-end">
        <v-btn
          class="mx-2" color="primary"
          fab icon x-small
          @click="addOne"
        >
          <v-icon>{{ icons.mdiPlus }}</v-icon>
        </v-btn>
      </div>
    </template>
      <template v-slot:item="{ item, index}">
         <tr>
        <td v-if="isFunctionColumnEnabled">
        <v-select
            v-model="item.govFunction"
            :items="govFunctionOptions"
            item-text="description"
            item-value="name"
            dense
            single-line
          ></v-select>
        </td>
        <td>
        <v-autocomplete
            v-model="item.department"
            :items="departments"
            item-text="deptDesc"
            item-value="_id"
            dense
            single-line
          ></v-autocomplete>
        </td>
           <td>
          <v-autocomplete
            v-model="item.account"
            :items="accounts"
            item-text="accDesc"
            item-value="_id"
            dense
            single-line
          ></v-autocomplete>
        </td>
        <td>
          <v-text-field
            v-model="item.purpose"
            dense
            single-line
          ></v-text-field>
        </td>
           <td>
          <v-text-field
            v-model.number="item.amountRequested"
            dense
            single-line
              @blur="roundAmount('amountRequested', index), footerTotalData()"
              @focus="amountToNum('amountRequested', index), $event.target.select()"
          ></v-text-field>
        </td>
           <td>
          <v-text-field
            v-model.number="item.amountApproved"
            dense
            single-line
            @blur="roundAmount('amountApproved', index), footerTotalData()"
            @focus="amountToNum('amountApproved', index), $event.target.select()"
          ></v-text-field>
        </td>
             <td>
          <v-icon
            small
            class="mr-2 war-trans-item-delete"
            tabindex="-1"
            @click="removeOne(item)"
          >
            {{ icons.mdiDelete }}
          </v-icon>
        </td>
      </tr>
    </template>
       <template slot="body.append">
    <tr class="sticky-table-footer">
      <td v-if="isFunctionColumnEnabled"></td>
      <td></td>
      <td></td>
      <td><strong>TOTALS</strong></td>
      <td><strong>{{amountFormat(totals.amountRequested)}}</strong></td>
      <td><strong>{{amountFormat(totals.amountApproved)}}</strong></td>
      <td></td>
    </tr>
    </template>

  </v-data-table>
    <div class="d-flex justify-end mt-4">
      <v-btn color="primary" @click="saveChanges">save</v-btn>
    </div>
  </div>
</template>

<script>
import {
  mdiDelete, mdiPlus,
} from '@mdi/js';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import { isBudgetedFundOrCashFund } from '../../shared/shared.util';
import { toFiscalYear } from '../../../util/shared/tmc-global';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';

// import { mapGetters } from 'vuex';
const fundCrudKey = 'sharedFund';
const departmentCrudKey = 'warDepartment';
const accountCrudKey = 'warAccount';
const baseCrudKeyConst = 'axAppropriations';

export default {
  name: 'approprationsUtils',
  data: () => ({
    baseCrudKey: baseCrudKeyConst,
    icons: {
      mdiDelete,
      mdiPlus,
    },
    isFunctionColumnEnabled: false,
    defaultItem: {
      govFunction: null,
      department: null,
      account: null,
    },
    totals: {
      amountRequested: 0,
      amountApproved: 0,
    },

  }),
  components: {
  },
  created() {
    this.intializeCriteria();
    this.loadApportionmentConfig();
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    headers() {
      const columns = [
        { name: 'deptCol', text: 'Department', value: 'department' },
        { name: 'accCol', text: 'Account:', value: 'account' },
        { name: 'purposeCol', text: 'Purpose', value: 'purpose' },
        { name: 'amtCol', text: 'Amount Requested', value: 'amountRequested' },
        { name: 'accCol', text: 'Amount Approved:', value: 'amountApproved' },
        {
          name: 'actCol', text: 'Actions', value: 'actions', sortable: false,
        },
      ];
      if (this.isFunctionColumnEnabled) {
        columns.unshift({ name: 'funcCol', text: 'Function', value: 'govFunction' });
      }
      return columns;
    },
    ...mapState({
      govFunctionOptions(state) {
        let values = state.enums.WarGovFunctionEnum || [];
        values = values.map((item, index) => ({
          ...item,
          description: `${index} ${item.description}`,
        }));
        return [{ name: null, description: '' }, ...values];
      },
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    editedItems: {
      get() {
        return this.items(this.baseCrudKey);
      },
      set(value) {
        this.setItems([this.baseCrudKey, value]);
      },
    },

    funds() {
      const fundObjs = this.items(fundCrudKey) || [];
      const updatedFundObj = fundObjs
        // Exclude fund 0000 and blank/non-numeric fund numbers from the list.
        .filter((f) => isBudgetedFundOrCashFund(f.type) && Number(f.fund) > 0)
        .map((f) => ({
          ...f,
          fundDesc: `${f.fund} ${f.description || ''}`,
        }));
      return [{ _id: null, fund: '', fundDesc: '' }, ...updatedFundObj];
    },
    // Fund NUMBER (year-agnostic logical key) for the selected latest-FY fund _id.
    selectedFundNo() {
      const selected = this.funds.find((f) => f._id === this.criteriaState.glFund);
      return selected ? selected.fund : null;
    },
    departments() {
      const departmentObjs = this.items(departmentCrudKey) || [];
      const updatedDeptObj = departmentObjs.map((d) => ({
        ...d,
        deptDesc: `${d.dept} ${d.description || ''}`,
      }));
      return [{ _id: null, dept: '', deptDesc: '' }, ...updatedDeptObj];
    },
    accounts() {
      const accountObjs = this.items(accountCrudKey) || [];
      const updatedAccObjs = accountObjs.map((a) => ({
        ...a,
        accDesc: `${a.account} ${a.shortDesc || ''}`,
      }));
      return [{ _id: null, account: '', accDesc: '' }, ...updatedAccObjs];
    },

  },
  methods: {
    ...mapActions('shared/fund', ['loadFunds']),
    ...mapActions('war/department', ['loadDepartments']),
    ...mapActions('war/account', ['loadAccounts']),
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapMutations('base/crud', ['setCriteria', 'setItems', 'setIndex']),
    ...mapMutations('apportionment/axAppropriationsUtils', [
      'setSelectedItems',
    ]),
    ...mapActions('apportionment/axAppropriationsUtils', [
      'loadaxAppropriationRecords',
      'upsertAxAppropriationsRecords',
      'deleteAxAppropriationsRecords',
      'clearAllAxAppropriations',
    ]),
    amountFormat,
    async clearAll() {
      const { glFund } = this.criteriaState;
      const fundNo = this.selectedFundNo;
      if (!glFund) {
        alert('Please select a fund first');
        return;
      }
      // eslint-disable-next-line no-restricted-globals, no-alert
      if (!confirm('Are you sure you want to zero out all amounts for this fund?')) {
        return;
      }
      await this.clearAllAxAppropriations({
        fundNo,
        baseCrudKey: this.baseCrudKey,
        postProcess: this.postProcessedData,
      });
      this.totals = {
        amountRequested: 0,
        amountApproved: 0,
      };
    },
    addOne() {
      this.editedItems = [...this.editedItems, { ...this.defaultItem }];
    },
    removeOne(item) {
      if (item._id) {
        this.editedItems = this.editedItems.filter((candidate) => item !== candidate);
        this.deleteAxAppropriationsRecords({ item });
      } else {
        this.editedItems = this.editedItems.filter((candidate) => item !== candidate);
      }
    },
    footerTotalData() {
      const totals = this.editedItems.reduce((acc, curr) => {
        acc.amountRequested += amountToNumber(curr.amountRequested) || 0;
        acc.amountApproved += amountToNumber(curr.amountApproved) || 0;
        return acc;
      }, { amountRequested: 0, amountApproved: 0 });
      this.totals = totals;
    },

    async loadApportionmentConfig() {
      const apportionmentSetting = await this.loadConfig({ requiredScope: 'apportionmentConfig' });
      this.isFunctionColumnEnabled = !!(apportionmentSetting && apportionmentSetting.length > 0
        && apportionmentSetting[0]
        && apportionmentSetting[0].configuration
        && apportionmentSetting[0].configuration.addFunctionColumnToApportionmentAppropriations);
    },
    intializeCriteria() {
      this.setCriteria([this.baseCrudKey, { glFund: null }]);
      this.editedItems = [];
      const departmentFields = {
        _id: '',
        dept: '',
        description: '',
      };
      this.loadDepartments({
        criteria: {
          sortBy: [
            {
              column: 'dept',
              direction: 'asc',
            },
          ],
        },
        fields: departmentFields,
        baseCrudKey: departmentCrudKey,
      });
      const accountFields = {
        _id: '',
        account: '',
        shortDesc: '',
      };
      this.loadAccounts({
        criteria: {
          sortBy: [
            {
              column: 'account',
              direction: 'asc',
            },
          ],
        },
        fields: accountFields,
        baseCrudKey: accountCrudKey,
      });
      const fy = toFiscalYear(new Date());

      this.loadFunds({
        criteria: {
          fiscalYear: fy || 0,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: fundCrudKey,
      });
    },
    postProcessedData(data) {
      // Build lookup maps so we can sort by the numeric dept/account values
      // rather than their ObjectId references stored in the collection.
      const deptMap = {};
      (this.items(departmentCrudKey) || []).forEach((d) => {
        deptMap[d._id] = Number(d.dept) || 0;
      });
      const accMap = {};
      (this.items(accountCrudKey) || []).forEach((a) => {
        accMap[a._id] = Number(a.account) || 0;
      });

      const sorted = [...data].sort((a, b) => {
        const deptDiff = (deptMap[a.department] || 0) - (deptMap[b.department] || 0);
        if (deptDiff !== 0) return deptDiff;
        return (accMap[a.account] || 0) - (accMap[b.account] || 0);
      });

      return sorted.map((d) => ({
        ...d,
        amountRequested: amountFormat(d.amountRequested),
        amountApproved: amountFormat(d.amountApproved),
      }));
    },
    async saveChanges() {
      const { baseCrudKey } = this;
      const { glFund } = this.criteriaState;
      if (glFund) {
        const updatedApprovedAmt = [];
        this.editedItems.forEach((item) => {
          const updatedItem = { ...item };
          // Existing rows keep their own _id/glFund so an edit updates in place
          // and never migrates a prior-FY record into the current FY (which would
          // leak it into the FY-scoped EON report). Only brand-new rows attach to
          // the selected latest-FY fund _id.
          if (!item._id) {
            updatedItem.glFund = glFund;
          }
          updatedItem.amountApproved = amountToNumber(item.amountApproved);
          updatedItem.amountRequested = amountToNumber(item.amountRequested);
          updatedApprovedAmt.push(updatedItem);
        });
        await this.upsertAxAppropriationsRecords({ item: updatedApprovedAmt, baseCrudKey });
        const res = await this.loadaxAppropriationRecords(
          {
            baseCrudKey,
            criteria: { fundNo: this.selectedFundNo },
            postProcess: this.postProcessedData,
          },
        );
        const totals = res.reduce((acc, curr) => {
          acc.amountRequested += amountToNumber(curr.amountRequested) || 0;
          acc.amountApproved += amountToNumber(curr.amountApproved) || 0;
          return acc;
        }, { amountRequested: 0, amountApproved: 0 });
        this.totals = totals;
      } else {
        alert('Please select fund to save appropriation');
      }
    },
    async searchByCriteria() {
      const { baseCrudKey } = this;
      const { glFund } = this.criteriaState;
      const fundNo = this.selectedFundNo;
      if (!glFund) {
        this.editedItems = [];
      } else {
        const res = await this.loadaxAppropriationRecords(
          {
            baseCrudKey,
            criteria: { fundNo },
            postProcess: this.postProcessedData,
          },
        );
        const totals = res.reduce((acc, curr) => {
          acc.amountRequested += amountToNumber(curr.amountRequested) || 0;
          acc.amountApproved += amountToNumber(curr.amountApproved) || 0;
          return acc;
        }, { amountRequested: 0, amountApproved: 0 });
        this.totals = totals;
      }
    },
    roundAmount(whichfields, index) {
      this.editedItems[index][whichfields] = amountFormat(amountToNumber(
        this.editedItems[index][whichfields],
      ));
    },
    amountToNum(whichfields, index) {
      this.editedItems[index][whichfields] = amountToNumber(this.editedItems[index][whichfields]);
    },

  },
};
</script>

<style scoped>
/* Center the page with comfortable left/right margin + padding. */
.appropriations-utils {
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px 32px;
}

.appropriations-utils .criteria-row {
  margin-bottom: 8px;
}

/* Tighten and normalise the table typography/padding. */
.appropriations-utils ::v-deep .war-appr-table table {
  font-size: 0.8125rem;
}

.appropriations-utils ::v-deep .war-appr-table th {
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}

.appropriations-utils ::v-deep .war-appr-table td {
  padding: 0 8px !important;
}

/* Compact the inline inputs so rows are not overly tall. */
.appropriations-utils ::v-deep .war-appr-table .v-input {
  font-size: 0.8125rem;
}

.appropriations-utils ::v-deep .war-appr-table .v-text-field input {
  padding: 4px 0;
}

/* Right-align the amount columns. Counted from the end (Actions is always
   last) so this holds whether or not the Function column is shown. */
.appropriations-utils ::v-deep .war-appr-table td:nth-last-child(2) input,
.appropriations-utils ::v-deep .war-appr-table td:nth-last-child(3) input {
  text-align: right;
}

@media (max-width: 600px) {
  .appropriations-utils {
    padding: 16px;
  }
}
</style>
